<template>
  <div id="headerinfo">
    <div class="head"
         id="head">
      <div class="head_m">
        <div class="topnav f_r">
          <div class="topnav f_r">
            <ul class="nav_menu">
              <li class="nav_menu-item"><a @click="changeLanguage('zh')"><img src="../images/language-ch.jpg" /></a></li>
              <li class="nav_menu-item"><a @click="changeLanguage('en')"><img src="../images/language-en.jpg" /></a></li>
            </ul>
          </div>
        </div>
        <div class="f_l h_mobile"></div>
        <div class=""
             id="destoon_member">
          <strong>{{ $t("header.computry")}}
          </strong>{{ $t("header.welcome")}}
          <span v-if="isLogin==true"
                style="color:red">{{userInfo.name}}
          </span>
          <span v-else>
            <span style="color:red"
                  @click="loginDialogVisible = true">{{ $t("header.login")}}</span> |
            <span style="color:red"
                  @click="registerDialogVisible = true">{{ $t("header.register")}}</span>
          </span>
          <!-- | <span  v-if="userInfo==null" style="color:red" @click="logout()">注销</span> -->
        </div>
      </div>
    </div>
    <div class="m header">
      <div class="logo f_l">
        <a href="https://www.seasunhk.com/">

          <img src="../images/header-logo.gif"
               alt="www.seasunhk.com">

        </a>
      </div>
      <div class="search_form f_l"
           style="width: 450px;">
        <!-- <form id="destoon_search"> -->
        <!-- target="_blank" enctype="multipart/form-data"  action=""   -->
        <div class="head_search"
             onmouseover="this.className='head_search_on';"
             onmouseout="this.className='head_search';">
          <div>
            <img class="search_img"
                 id="imgsearch"
                 style="display: none">
            <!-- <input name="desckey"
                   id="desckey"
                   ref="desckey"
                   type="text"
                   class="search_i"
                   value=""
                   @keyup.enter.native="checkdesckeyform"
                   onfocus="if(this.value=='请输入关键词') this.value='';"
                   autocomplete="off"
                   x-webkit-speech=""
                   speech=""> -->
            <el-input :placeholder="$t('header.keyword')"
                      v-model="keyword"
                      @keyup.enter.native="checkdesckeyform"
                      class="search_i"></el-input>

            <el-upload class="upload-demo"
                       accept="image/*"
                       style="position: relative;display: inline-block;"
                       action="http://localhost:50622/api/ApiProduct/SearchPicture"
                       :on-success="handleSuccess"
                       :show-file-list="false"
                       :http-request="handleHttpRequest">
              <span id="destoon_select"
                    onmouseover="this.className='search_m_on';"
                    onmouseout="this.className='search_m';"
                    class="search_m"
                    value=""
                    readonly="true"></span>
            </el-upload>
            <!-- <span id="destoon_select"
                  onmouseover="this.className='search_m_on';"
                  onmouseout="this.className='search_m';"
                  class="search_m"
                  value=""
                  readonly="true"></span> -->

            <input type="button"
                   @click="checkdesckeyform()"
                   value=" "
                   class="search_s">
            <!-- <input type="file"
                   style="display: none;"
                   accept=".jpg,.jpeg,.png"
                   name="searchimg"
                   id="searchimg"> -->

            <img id="searchimgshow">
          </div>
        </div>
        <!-- </form> -->
        <div class="head_search_kw">
          <span id="destoon_word">
            <a @click="gohighsearch"
               style="color: #FF6600"><strong>{{$t("header.highsearch")}}</strong></a>
          </span>
        </div>
      </div>
      <div class="head_buy f_l">
        <el-button type="warning"
                   @click="gotocart()"
                   round
                   icon="el-icon-shopping-cart-2">{{ $t("header.buyshop")}}</el-button>
        <!-- <button onclick="showvideobtn()"  data-toggle="modal" data-target="#myModal" class="btn btn-success"  rel="nofollow"><i class="fa fa-file-video-o"></i>&nbsp;&nbsp;&nbsp;Product Video</button> -->
        <!-- <button onclick="javascript:window.location.href='/purchaseManage/purchaseDemand.html'" class="btn btn-warning" rel="nofollow"><i class="fa fa-bookmark-o"></i>&nbsp;&nbsp;&nbsp;发布产品需求</button> -->

      </div>
      <!-- 一键分享 -->

      <div class="c_b"></div>
    </div>
    <div class="menuborder">
      <div class="m">
        <div class="allcat f_l"
             id="divallcatf_l">
          <span><a href="/#/product"
               class="w"
               target="_blank">{{ $t("header.allproduct")}}</a></span>
        </div>
        <div class="menu f_r">
          <ul>
            <li><a href="/#/"
                 target="_blank"><span>{{ $t("footer.home")}}</span></a></li>
            <!-- class="menuon" -->

            <!-- <li><a href="/#/product" target="_blank"><span>{{ $t("header.product")}}</span></a></li> -->
            <!-- <li><a href="/#/product/{prod_name:'3C'}"
                 target="_blank"><span>{{ $t("header.productccc")}}</span></a></li> -->
            <!-- <li><a target="_blank"
                 href="/#/video"><span>{{ $t("header.video")}}</span></a></li> -->

            <!-- <li><a href="https://www.seasuntoys.cn/"
                 target="_blank"><span>{{ $t("header.star")}}</span></a></li> -->
            <li><a target="_blank"
                 href="/#/about"><span>{{ $t("header.about")}}</span></a></li>
            <!-- <li><a href="/#/contact"><span>{{ $t("header.contact")}}</span></a></li> -->
            <li><a target="_blank"
                 href="/#/plan"><span>{{ $t("header.plan")}}</span></a></li>
            <!-- <li><a target="_blank"
                 href="/#/news"><span>{{ $t("header.news")}}</span></a></li> -->
            <li class="sgo">

              <a target="_blank"
                 href="https://www.icbc.com.cn/column/1438058341489590354.html">{{ $t("header.Exchange")}}</a>

            </li>

            <!-- http://www.icbc.com.cn/icbc/%E9%87%91%E8%9E%8D%E4%BF%A1%E6%81%AF/%E5%A4%96%E6%B1%87%E7%89%8C%E4%BB%B7/%E4%BA%BA%E6%B0%91%E5%B8%81%E5%A4%96%E6%B1%87%E7%89%8C%E4%BB%B7/default.htm -->
          </ul>
        </div>
        <div class="c_b"></div>
      </div>
    </div>
    <div class="m">
      <div class="f_l">

        <!--代码部分begin-->
        <div class="allcatsub"
             id="divallcatsub"
             style="display: none;">
          <div v-for="(big,index3) in classs"
               :key="big.id"
               class="item"
               onmouseover="this.className=&#39;item on&#39;"
               onmouseleave="this.className=&#39;item&#39;">
            <h3 :class="'icon'+(index3+1)">
              <a :href="'/#/product/{bigclassid:'+big.id+'}'"
                 target="_blank">
                &nbsp;&nbsp;
                <span v-if="$i18n.locale=='en'">{{big.name_en}}</span>
                <span v-else>{{big.name}}</span>
              </a>
            </h3>
            <a :href="'/#/productdetail/'+big.id"
               target="_blank"></a>
            <div class="i-mc">
              <h4>
                <span class="le"
                      v-if="$i18n.locale=='en'">{{big.name_en}}</span>
                <span class="le"
                      v-else>{{big.name}}</span>
              </h4>
              <div>&nbsp;</div>
              <div>
                <a v-for="p in big.subs"
                   :key="p.id"
                   style="width: 280px;border-bottom: 1px solid #E6E6FA;padding:3px;"
                   :href="'/#/product/{smallclassid:'+p.id+'}'"
                   target="_blank">
                  <font color="#FFA500">{{p.id}}</font>&nbsp;&nbsp;
                  <span class="le"
                        v-if="$i18n.locale=='en'">{{p.name_en}}</span>
                  <span class="le"
                        v-else>{{p.name}}</span>
                </a>

              </div>
            </div>
          </div>
        </div>
        <!--代码部分end-->
      </div>
    </div> <!-- 模态 - 选择人员 -->
    <el-dialog :title="$t('header.login')"
               width="400px"
               :visible.sync="loginDialogVisible"
               :modal-append-to-body='false'>
      <el-form :model="form">
        <el-form-item :label="$t('header.account')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.account"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.password')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.password"
                    autocomplete="off"
                    show-password></el-input>
        </el-form-item>
        <el-form-item label=" "
                      label-width="290px">
          <el-button type="primary"
                     @click="login()">{{$t('common.ok')}}</el-button>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('header.notuser')">
          <el-button type="success"
                     @click="loginnew()">{{$t('header.registernew')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('header.register')"
               width="400px"
               :visible.sync="registerDialogVisible"
               :modal-append-to-body='false'>
      <el-form :model="form">
        <el-form-item :label="$t('header.account')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.account"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.password')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.password"
                    autocomplete="off"
                    show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.name')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.name"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.phone')"
                      :label-width="formLabelWidth">
          <el-input v-model="form.phone"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="registerDialogVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
                   @click="register()">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>

  </div>

</template>
<script>
import fetch from "@/utils/axios";
export default {
  name: "Header",
  data () {
    return {
      classs: [],
      msg: "头部",
      show: false,
      isLogin: false,
      loginDialogVisible: false,
      registerDialogVisible: false,
      form: { account: '', password: '' },
      formLabelWidth: '100px',
      userInfo: null,
      keyword: null,
    };
  },
  methods: {
    gologininfodata () {
      this.loginDialogVisible = true
    },
    gohighsearch () {
      var hash = window.location.hash;
      if (hash == '#/') {
        window.location = "/#/home#product-categoriessearch";
        location.reload();
      } else {
        var newwindow = window.open("_blank");
        newwindow.location = "/#/home#product-categoriessearch";
      }
    },
    handleHttpRequest (para) {
      if (this.isLogin) {
        var form = new FormData();
        form.append("file", para.file);
        fetch.fileUpload("/api/ApiProduct/SearchPicture", form).then(
          (res) => {
            if (res) {
              var newwindow = window.open("_blank");
              newwindow.location = "/#/product/{picture:'" + res + "'}";
              //window.open("/#/product/{picture:'" + res + "'}", "_blank")
            }
          })
      } else {
        this.loginDialogVisible = true;
      }
    },
    handleSuccess (response, file, fileList) {
      alert(JSON.stringify(response))
      //window.open("/#/product/{picture:'" + this.response + "'}", "_blank")
      // alert(JSON.stringify(response))
    },
    checkdesckeyform () {
      window.open("/#/product/{keyword:'" + this.keyword + "'}", "_blank")
    },
    changeLanguage (va) {
      this.$i18n.locale = va
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
      //window.location.href="/"
    },
    jumppage (url) {
      var temp = window.location.href
      window.location.href = url
      if (temp.indexOf('/product/') > -1) {
        location.reload();
      }
      //this.$router.push({path:'/product'})
    },
    gotocart () {
      if (this.isLogin) {
        window.location.href = '/#/cart'
      } else {
        this.$message('请先登录！');
        this.loginDialogVisible = true;
      }
    },
    remind () {
      this.$toast("3");
    },
    searchHandle () {
      var temp = window.location.href
      window.location.href = "/#/product/0/" + this.$refs.desckey.value;
      if (temp.indexOf('/product/') > -1) {
        location.reload();
        this.$refs.keyword.value = "";
      }
    },
    loginnew () {
      this.loginDialogVisible = false;
      this.registerDialogVisible = true;
    },
    login () {
      const pparams = { account: this.form.account, password: this.form.password }; // 参数
      fetch.post("/api/ApiUser/Login", pparams).then(
        (res) => {
          this.$message('登录成功');
          localStorage.setItem("userInfo", JSON.stringify(res))
          this.userInfo = res;
          this.loginDialogVisible = false;
          this.isLogin = true;
          localStorage.setItem("isLogin", true)
          if (window.location.href.indexOf('/productdetail/') > -1) {
            location.reload();
          }
        },
        (error) => {
          localStorage.setItem("isLogin", false)
          this.isLogin = false;
          this.$message(error.message);
        }
      );
    },
    register () {
      const pparams = { account: this.form.account, password: this.form.password, name: this.form.name, phone: this.form.phone }; // 参数
      fetch.post("/api/ApiUser/Register", pparams).then(
        (res) => {
          this.$message('注册成功');
          localStorage.setItem("userInfo", JSON.stringify(res))
          this.userInfo = res;
          localStorage.setItem("isLogin", true)
          this.isLogin = true;
          this.registerDialogVisible = false;
        },
        (error) => {
          localStorage.setItem("isLogin", false)
          this.isLogin = false;
          this.$message(error.message);
        }
      );
    },

  },
  mounted () {
    if (localStorage.getItem("userInfo") == null) {
      this.userInfo = null
    } else {
      try {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        this.isLogin = localStorage.getItem("isLogin")
      } catch (e) {
        localStorage.setItem("userInfo", null)
        localStorage.setItem("isLogin", false)
        this.isLogin = false;
        this.userInfo = null;
      }
    }
    if (this.isLogin) {
      fetch.post("/api/ApiUser/IsLogin", params).then(
        (res) => {
          localStorage.setItem("userInfo", JSON.stringify(res))
          this.userInfo = res;
          this.loginDialogVisible = false;
          this.isLogin = true;
          localStorage.setItem("isLogin", true)
        },
        (error) => {
          localStorage.setItem("userInfo", null)
          localStorage.setItem("isLogin", false)
          this.isLogin = false;
          this.userInfo = null;
        }
      );
    }
    // 使用
    const params = {}; // 参数
    fetch.post("/api/ApiProClass/GetAllClass", params).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );

    $("#divallcatf_l").mouseover(function () {
      $(".allcatsub").show();

    });


    $("#divallcatf_l").mouseleave(function (e) {
      var x = e.pageX;
      var y = e.pageY;

      var div = $('.allcatsub');
      var y1 = div.offset().top;
      var y2 = y1 + div.height();

      var x1 = div.offset().left;
      var x2 = x1 + div.width();
      if (x < x1 || x > x2 || y < y1 || y > y2) {
        $(".allcatsub").hide();
      }
    });


    $("#divallcatsub").mouseleave(function () {
      $(".allcatsub").hide();
      //$(".allcatsub").hide();
    });

    $('#desckey').on('keypress', function (event) {
      if (event.keyCode == 13) {
        checkdesckeyform();
        window.location.href = "/#/product/{" + this.$refs.desckey.value;
      }

    });
  }
};
</script>
<style scoped>
#headerinfo {
  /* position: fixed; */
  top: 0px;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 192px;
  background-color: #fff;
  z-index: 999;
  text-align: left;
}
.model {
  width: 50%;
  height: 50%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.search_i >>> .el-input__inner {
  border: 0px;
  height: 35px;
}
.modelFixed {
  position: absolute;
  top: 120px;
  left: 10px;
  padding: 5px;
  background: #ffffff;
  box-shadow: 3px 2px 5px #7777;
}
.search_form {
  margin-left: 100px;
}
#title {
  width: 1400px;
  height: 192px;
  display: inline-block;
}
#left {
  display: flex;
  text-align: left;
  float: left;
}
#left img {
  padding-top: 5px;
}
#sub_bottom {
  padding-top: 6px;
  padding-left: 10px;
}
#right {
  text-align: right;
  float: right;
  padding-top: 10px;
}
#sub_top {
  padding-top: 10px;
  height: 24px;
}

.nav {
  width: 100%;
}
.nav li {
  float: right;
  font-size: 17px;
  width: 68px;
  text-align: center;
  margin-left: 40px;
  height: 90px;
  line-height: 90px;
}
.nav li a {
  color: #333;
}
.nav li:hover a {
  color: #00a0e9;
}
.nav li:hover {
  background: url(../images/nav_bg.jpg) no-repeat bottom center;
}
.nav li.on a {
  color: #00a0e9;
}
.nav li.on {
  background: url(../images/nav_bg.jpg) no-repeat bottom center;
}
/*语言选择2*/
.search {
  width: 202px;
  height: 30px;
  margin: 25px 0px;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 30px;
}
.search img {
  width: 19px;
  height: 19px;
  position: absolute;
  left: 10px;
  top: 5px;
}
.search input {
  width: 150px;
  height: 30px;
  line-height: 30px;
  border: none;
  position: absolute;
  left: 35px;
  background-color: #f5f5f5;
  font-size: 12px;
  color: #a4a4a4;
}
/*语言选择1*/
.lang {
  width: 120px;
  height: auto;
  position: relative;
}
.language {
  width: 120px;
  height: 30px;
  margin: 20px 0;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 30px;
  font-size: 12px;
  color: #a4a4a4;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.language img {
  width: 12px;
  height: 7px;
  position: absolute;
  right: 10px;
  top: 12px;
}

.lang .chose {
  display: block;
  position: absolute;
  width: 120px;
  height: 105px;
  background-color: #fff;
  left: 0;
  bottom: -85px;
  z-index: 999;
  text-align: center;
  font-size: 12px;
  border-radius: 0 0 15px 15px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
}
.lang .chose a {
  display: block;
  width: 120px;
  height: 35px;
  line-height: 35px;
}
.lang .chose a img {
  display: inline-block;
  width: 23px;
  height: 16px;
  position: relative;
  left: 20px;
  top: 8px;
}
.language1 {
  background-color: #fff;
  box-shadow: 0px -1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 15px 15px 0 0;
}
/*语言选择2*/
.langcn {
  width: 30px;
  height: 30px;
  background-image: url(../images/cn.png);
  margin: 25px 40px 25px 20px;
}
.langen {
  width: 30px;
  height: 30px;
  background-image: url(../images/en.png);
  margin: 25px 40px 25px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue